"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _IconResultSection = _interopRequireDefault(require("../result/IconResultSection"));

var _RadialResultSection = _interopRequireDefault(require("../result/RadialResultSection"));

var _YesNoResultSection = _interopRequireDefault(require("../result/YesNoResultSection"));

var _FlipCardResultSection = _interopRequireDefault(require("../result/FlipCardResultSection"));

var ResultSection = function ResultSection(_ref) {
  var results = _ref.results,
      websiteGrade = _ref.websiteGrade;

  var getGrade = function getGrade(result) {
    return websiteGrade.getIn(result.resultKeyPath, false);
  };

  return results.map(function (result, index) {
    // Init the result with the grade
    result.init(getGrade(result));
    result.key = index; // Determine the correct ResultSection component to use to display the result

    if (result.progressBarIcon) {
      return _react.default.createElement(_RadialResultSection.default, result);
    } else if (result.resultIcon) {
      return _react.default.createElement(_IconResultSection.default, result);
    } else if (result.resultFlipCard) {
      return _react.default.createElement(_FlipCardResultSection.default, result);
    } else {
      return _react.default.createElement(_YesNoResultSection.default, result);
    }
  });
};

var _default = ResultSection;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/pages/ResultSection.js
// module id = 67
// module chunks = 0